<script setup>
import { ref, watch } from 'vue';
import { __ } from '@/utils';
import { formFragmentValues, setFormFragmentValues } from "@/utils";
import { useField } from 'vee-validate';

const props = defineProps({
	tabs: Array,
});

const activeTabOptions = ['Private Client', 'Business Client']

const localValues = formFragmentValues();
const activeTab = ref(localValues.detailsTab !== undefined ? localValues.detailsTab : 0);

const { handleChange } = useField('activeTab');

handleChange(localValues.detailsTab !== undefined ? activeTabOptions[localValues.detailsTab] : activeTabOptions[0]);


watch(activeTab, () => {
	setFormFragmentValues({
		detailsTab: activeTab.value
	})
	handleChange(activeTabOptions[activeTab.value]);
});
</script>
<template>
	<div class="tabs">
		<header class="tabs__head" v-if="tabs.length > 0">
			<nav class="tabs__nav">
				<ul>
					<li v-for="(header, index) in tabs" :key="index" :class="{ 'is-active': index === activeTab }">
						<a href="#" @click.prevent="activeTab = index">
							<component v-if="header.icon" :is="header.icon" />
							{{ __(header.title) }}
						</a>
					</li>
				</ul>
			</nav><!-- /.tabs__nav -->
		</header><!-- /.tabs__head -->

		<div class="tabs__body">
			<template v-for="(tab, index) in tabs" :key="index">
				<div class="tabs__tab" v-if="index === activeTab">
					<component v-for="(fragment, fragmentIndex) in tab.body" :key="fragmentIndex"
						:is="fragment.component" v-bind="fragment.props" />
				</div>
			</template>
		</div><!-- /.tabs__body -->
	</div><!-- /.tabs -->
</template>
